<template>
  <section>
    <div class="bottom-profile">

      <!-- 底部图标 -->
      <div class="log">
        <img src="@/assets/img/home/logo.jpg" height="90">
        <span>结盟连锁，全球首创</span>
      </div>

      <!-- 联系方式 -->
      <div class="contact">
        <p>
          关于我们：客主酒店连锁隶属于上海客主网络科技有限公司，是致力于为酒店打造公平合理的经营环境的连锁酒店品牌。
          <br>
          联系我们：上海市闵行区剑川路 951 号零号湾 2 号楼 3 楼；021 - 57466066
          <br>
          版权所有：上海客主商务服务有限公司
          <br>
          备&ensp;案&ensp;号：<a target="_blank" href="http://www.miibeian.gov.cn/">沪ICP备07024040号</a>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BottomContent'
}
</script>

<style lang="scss" scoped>
section {
  width: calc(1vw * 100);
  background: #043d5d;

  .bottom-profile {
    width: 1200px;
    height: 150px;
    margin: 0 auto;
    color: #c7c8c9;
    display: grid;
    grid-template-columns: 1.5fr 2fr;

    .log {
      align-self: center;
      justify-self: center;

      img {
        display: inline-block;
        box-sizing: border-box;
        vertical-align: middle;
      }

      span {
        margin: 0 0 0 15px;
        display: inline-block;
        box-sizing: border-box;
        vertical-align: middle;
        font-size: 40px;
        font-family: 楷体;
      }
    }

    .contact {
      font-size: 14px;
      line-height: 25px;
      align-self: center;

      a {
        color: #68c39f;
      }

      a:hover {
        color: #c7c8c9;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu_components/BottomContent.vue